import styled from 'styled-components';
import { styleVariables } from '@lib/common';
import { countWords } from './essay-text-metrics';
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledMetrics = styled.span.withConfig({
  displayName: "essay-answer-metricscomponent__StyledMetrics",
  componentId: "sc-93c0ct-0"
})(["display:inline-flex;align-items:center;min-height:32px;border-radius:8px;background:", ";color:", ";font-size:14px;font-weight:600;letter-spacing:0.02em;padding:4px 12px;font-variant-numeric:tabular-nums;"], styleVariables.colors.gray3, styleVariables.colors.grey70);
export var EssayAnswerMetrics = function EssayAnswerMetrics(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      label = _ref.label;
  return /*#__PURE__*/_jsxs(StyledMetrics, {
    children: [countWords(value), " ", label.words || 'words']
  });
};